import React, { useEffect, useState } from 'react';
import { listTitleNotification } from '../list-sidebar';
import { RequestDataSetting, updateSettingChat } from 'api/chat/setting/update-setting';
import { useSubscription } from 'hooks/use-subscription.hook';

interface IMessageProps {
  self: RequestDataSetting;
}

function Notification({ self }: IMessageProps) {
  const [listActiveNotify, setListActiveNotify] = useState({ ...self, isCheckChangeContent: false });
  const subscription = useSubscription();

  const handlechange = (e) => {
    setListActiveNotify({
      ...listActiveNotify,
      isCheckChangeContent: true,
      is_notify_message:
        e.target.value === 'is_notify_message'
          ? !listActiveNotify.is_notify_message
          : listActiveNotify.is_notify_message,
      is_notify_sound:
        e.target.value === 'is_notify_sound' ? !listActiveNotify.is_notify_sound : listActiveNotify.is_notify_sound,
      is_show_sum_msg:
        e.target.value === 'is_show_sum_msg' ? !listActiveNotify.is_show_sum_msg : listActiveNotify.is_show_sum_msg,
      is_notify_desktop:
        e.target.value === 'is_notify_desktop'
          ? !listActiveNotify.is_notify_desktop
          : listActiveNotify.is_notify_desktop,
    });
  };

  useEffect(() => {
    if (!listActiveNotify.isCheckChangeContent) return;

    const chatSettingSub = updateSettingChat(self._id, {
      is_notify_message: listActiveNotify.is_notify_message,
      is_notify_sound: listActiveNotify.is_notify_sound,
      is_show_sum_msg: listActiveNotify.is_show_sum_msg,
      is_notify_desktop: listActiveNotify.is_notify_desktop,
    }).subscribe();

    subscription.add(chatSettingSub);
  }, [listActiveNotify, subscription, self._id]);

  return (
    <div className='notification'>
      {listTitleNotification(listActiveNotify).map((courst, idx) => (
        <div key={idx} className='tab-item'>
          <li className='list-group-item'>
            {courst.label}
            <label className='switch'>
              <input
                type='checkbox'
                value={courst.value}
                checked={courst.isCheckStatus}
                onChange={handlechange}
                className='success'
              />
              <span className='slider round'></span>
            </label>
          </li>
        </div>
      ))}
    </div>
  );
}

export default Notification;
